import { render, staticRenderFns } from "./list-user-groups.vue?vue&type=template&id=6c31300a&"
import script from "./list-user-groups.vue?vue&type=script&lang=tsx&"
export * from "./list-user-groups.vue?vue&type=script&lang=tsx&"
import style0 from "./list-user-groups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports